import { useEffect, useState } from "react";
import {
  Link,
  useLoaderData,
  useParams
} from "react-router-dom";
import * as API from "../services/vispsicologicas";
import * as APITRATAMIENTO from "../services/tratamientos";


export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getVispsicologicasByID(params.vispsicologicasId);
}


export function VispsicologicasItem(props) {
  const vispsicologicas = useLoaderData();
  const errorMessage = vispsicologicas.message;

  const vispsicResp = vispsicologicas.meta?.vispsicResp;
  const vispsicFecha = vispsicologicas.meta?.metaFecha;
  const vispsicHora = vispsicologicas.meta?.vispsicHora;
  const vispsicObs = vispsicologicas.meta?.vispsicObs;

  const vispsicDate = new Date(vispsicologicas.date);
  const diffDate = (Math.abs(new Date() - vispsicDate) / 36e5);

  const [permisoTemporalPsicohosp, setPermisoTemporalPsicohosp] = useState(false);

  let { tratamientoId } = useParams();

  useEffect(() => {
    const loadTratamientoData = async () => {
      // Obtener los datos del tratamiento
      const tratamiento = await APITRATAMIENTO.getTratamientoById(tratamientoId);

      // Verificar si el especialistaId está en meta.psicohosp
      const permiso = tratamiento.meta.psicohosp.some(
        (psicologo) => {
          return psicologo.value === props.especialistaId;
        }
      );
  
      // Guardar el resultado en el estado
      setPermisoTemporalPsicohosp(permiso);
    };
  
    loadTratamientoData();
  }, [tratamientoId, props.especialistaId]);

  return (
    <>
    <div id="content">
      {vispsicologicas.length === 0 ? (
        <div>Cargando...</div>
      ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
      <form id="formUpdatelement">
        <fieldset id="disabledContainer" disabled="disabled">
        <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='vispsicResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicResp'
                  required
                  type='text'
                  readOnly
                  value={vispsicResp}

                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='vispsicFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='vispsicFecha'
                  required
                  type='date'
                  readOnly
                  value={vispsicFecha}

                />
              </div>
            </div>
            {/* <div className='field'>
              <label htmlFor='vispsicHora'>Hora de Visita</label>
              <div className='control'>
                <input
                  readOnly
                  className='input'
                  id='vispsicHora'
                  required
                  type='time'
                  value={vispsicHora}
                />
              </div>
            </div> */}
          </div>
          <div className='field'>
            <label htmlFor='vispsicObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='vispsicObs'
                id='vispsicObs'
                readOnly
                value={vispsicObs}

              ></textarea>
            </div>
          </div>

      </fieldset>
      </form>
      ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72 && props.userRole.includes('psicologia-hospital')) || (props.userRole.includes('administrador')) || (diffDate <= 72 && permisoTemporalPsicohosp))  && (
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      )}
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || permisoTemporalPsicohosp) && (
      <Link className="button is-link" to={`../${tratamientoId}/hospitalizacion/visitas-psicologicas/new`}>Nuevo</Link>
      )}
      </div>
      }
    </>
  );
}
